import {Card, Box, Typography, useTheme, Link, Grid} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {PropTypes} from '../type';
import {ChevronDown} from '@jobseeker/lotus/icons';
import {GraduationHat} from '@jobseeker/lotus/images';

export default ({children, ...props}: PropTypes) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        position: 'relative',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="subtitle2" sx={{mb: 0.5}}>
        {props.title}
      </Typography>
      <Grid container spacing={{xxs: 1, md: 2}}>
        <Grid item xxs={12} md={'auto'}>
          <Box
            width={150}
            height={92}
            position={'relative'}
            overflow={'hidden'}
            borderRadius={2}
          >
            <Image
              src={
                props.imageUrl ??
                'https://d1d480vo8909cx.cloudfront.net/media/169657/U-169657-01/templateImages1674566384767_cropped.jpg'
              }
              alt={'Arrow'}
              layout="fill"
              objectFit="cover"
            />
          </Box>
        </Grid>
        <Grid item xxs={12} md>
          <Typography variant="subtitle2">{props.subTitle}</Typography>
          <Typography variant="body3" color="#808285">
            {props.description ??
              `
            This is an inclusive business network for our LGBTQ+ community and
            it is all about breaking down barriers of difference and connecting
            people. Shine celebrates each person’s uniqueness, regardless of
            sexuality, race, gender, religion...........`}
          </Typography>
          <Link
            href={props.actionUrl}
            target="_blank"
            sx={{
              textDecoration: 'none',
              cursor: 'pointer',
              // display: 'flex',
              // alignItems: 'center',
            }}
          >
            <Typography component={'p'} variant="subtitle3">
              {props.actionLabel}
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};
